import classNames from "classnames/bind";
import styles from "../../styles/proposal/AdjProcess.module.css";
import adjData from "../../data/aboutAdj.json";
import { useRef } from "react";

const cx = classNames.bind(styles);
//손해사정 절차
export default function AdjProcess() {
  const itemsRef = useRef([]);

  return (
    <>
      <div className={cx("timeLineSection", "wrapper")}>
        <div className={cx("title")}>
          <h4>{adjData.process.title}</h4>
        </div>

        <div className={cx("timeLine")}>
          {adjData.process.steps.map((step, index) => (
            <div
              key={index}
              ref={(el) => (itemsRef.current[index] = el)}
              className={cx("timeLineItem", "reveal")}
            >
              <div className={cx("adjDataItemBox", "card", "liftUp")}>
                <div className={cx("circle")}>{index + 1}</div>
                <div>
                  <h5>{step.title}</h5>
                  <p>{step.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
